import { DataNode, FormDefinitionWrapper, parseFieldIdentifier } from "../react/components/form/services";
import { computeInitialState } from "../redux";

export const getDefaultData = (absolutePath: string, form: FormDefinitionWrapper) => {
  let field = parseFieldIdentifier(absolutePath);
  field = field.replace('/',''); // Removes the first slash
  let hasDefinitionData = false;
  
  // Using the form definition
  let formDefinitionData = form.definition.data;
  // Drill down into the form definition to find the subform
  field.split('/').forEach((segment) => {
    if (Number.isInteger(segment) === false) { // Skip the indexes in arrays
      if (formDefinitionData.properties && formDefinitionData.properties[segment]) {
        formDefinitionData = formDefinitionData.properties[segment];
        hasDefinitionData = true;
      }
      if (formDefinitionData.items) {
        formDefinitionData = formDefinitionData.items;
        hasDefinitionData = true;
      }
    }
  });

  if (!hasDefinitionData) {
    return {};
  }
  return computeInitialState(formDefinitionData as DataNode);
}